import {createSelector} from 'reselect';
import {getSettings} from './selectors';

export default createSelector(
  [getSettings],
  settings => !!settings?.should_validate_contact_number_on_place_order,
);
